import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';

const PublicLayout = () => {
    const navigate = useNavigate();
    const [isRender, setIsRender] = useState(false);

    const isLoggedIn = useSelector((state) => state.auth.userToken);

    useEffect(() => {
        if (isLoggedIn) {
            navigate("/dashboard", { replace: true })
        } else {
            setIsRender(true);
        }
    }, [isLoggedIn, navigate]);

    if (!isRender) {
        return null;
    }

    return <Outlet />;
}

export default PublicLayout;